import { getAllReturnedAndStaleOrders } from '@/API/repositories/order';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useEffect, useState } from 'react';

const useFollowUpShipments = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const [displayedRows, setDisplayedRows] = useState();

	const isLoading = hasUnfilledRequest(getAllReturnedAndStaleOrders);

	const fetchStaleOrders = async (payload = {}) => {
		const response = await makeRequest(
			getAllReturnedAndStaleOrders.bind(null, payload),
		);

		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}

		setDisplayedRows(response.data);
	};

	useEffect(() => {
		fetchStaleOrders();
	}, []);

	return {
		displayedRows,
		fetchStaleOrders,
		isLoading,
	};
};

export default useFollowUpShipments;
